import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const BrandTile = ({
  to,
  color,
  large,
  className,
  children,
}) => pug`
  Link.tile.tile--brand(to=to, className=className, style={ '--color-accent': color })
    .tile__content.tile__content--centered
      .tile--brand__logo(className=(large ? "tile--brand__logo--large" : ""))=children
`;

BrandTile.defaultProps = { className: '' };

BrandTile.propTypes = {
  to: PropTypes.string.isRequired,
  color: PropTypes.string,
  large: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
};

export default BrandTile;
